module.exports = __webpack_public_path__ + "img/20_Email.610cd5d8.svg";